(function () {
  function positionGiftIcon() {
    var icon = document.getElementById('sca-gift-icon');
    if (!icon) return;

    var media = document.querySelector('.product__media-container');
    if (media && icon.parentNode !== media) {
      media.appendChild(icon);
    }
  }

  var observer = new MutationObserver(positionGiftIcon);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', positionGiftIcon);
  positionGiftIcon();
}());
